export enum TipoCredorComissoesEntidade {
  Publica = 0,
  Privada = 1
}

export const TipoCredorComissoesEntidadeLabel = new Map<TipoCredorComissoesEntidade, string>([
  [TipoCredorComissoesEntidade.Publica, "Publica"],
  [TipoCredorComissoesEntidade.Privada, "Privada"],
]);
